// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-interface {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: var(--surface-color);
  transition: background-color 0.3s ease;
  position: relative;
}

.dark .chat-interface {
  background: #1f2937;
}

.chat-empty-state {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 3rem 2rem 2rem;
  text-align: center;
  color: #6e6e80;
  transition: color 0.3s ease;
}

.chat-empty-state.embedded {
  padding-top: 2.6rem;
}

.chat-empty-state.entrance {
  padding-top: 4.25rem;
}

.dark .chat-empty-state {
  color: #9ca3af;
}

.chat-empty-state h2 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  transition: color 0.3s ease;
}

.dark .chat-empty-state h2 {
  color: #f9fafb;
}

.chat-empty-state p {
  max-width: 35rem;
}

.chat-empty-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 6rem;
  overflow: visible;
}

.chat-empty-copy h2 {
  margin-top: 0;
}

.chat-empty-copy p {
  margin: 0;
}

.chat-empty-single-column-prompt {
  color: #4b5563;
  font-size: 0.98rem;
  font-weight: 600;
  line-height: 1.35;
  margin-top: 2.4rem !important;
}

.dark .chat-empty-single-column-prompt {
  color: #d1d5db;
}

.oars-messages--loading {
  padding-top: 1.5rem;
}

.oars-session-position-indicator--loading {
  margin-bottom: 1rem;
}

.oars-loading-message {
  opacity: 1;
}

.oars-loading-bubble {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.62rem;
  min-width: min(33rem, 78%);
  padding: 1rem 1.05rem;
  border-radius: 18px;
  background: #eef2f7;
  border: 1px solid rgba(148, 163, 184, 0.22);
}

.oars-loading-bubble::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.7), transparent);
  animation: oarsLoadingSweep 1.8s infinite ease-in-out;
}

.dark .oars-loading-bubble {
  background: #2a3445;
  border-color: rgba(148, 163, 184, 0.18);
}

.dark .oars-loading-bubble::after {
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
}

.oars-loading-bubble--wide {
  min-width: min(34rem, 80%);
}

.oars-loading-bubble--client {
  min-width: min(24rem, 66%);
  margin-right: auto;
  background: #f5efe6;
}

.dark .oars-loading-bubble--client {
  background: #3a3027;
}

.oars-loading-line {
  display: block;
  height: 0.78rem;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.42);
}

.dark .oars-loading-line {
  background: rgba(203, 213, 225, 0.18);
}

.oars-loading-line--long {
  width: 88%;
}

.oars-loading-line--mid {
  width: 64%;
}

.oars-loading-line--short {
  width: 42%;
}

.oars-cut-indicator--loading {
  margin-top: 1rem;
}

@keyframes oarsLoadingSweep {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--app-chat-header-padding-block, 1.5rem) var(--app-chat-header-padding-inline, 2rem);
  min-height: 4.68rem;
  border-bottom: 1px solid #e5e7eb;
  transition: border-color 0.3s ease;
  flex-shrink: 0;
  gap: 1rem;
}

.dark .chat-header {
  border-bottom-color: #374151;
}

.chat-header-title-row {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  min-width: 0;
  flex: 1 1;
  flex-wrap: nowrap;
}

.chat-header h3 {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 600;
  color: #111827;
  letter-spacing: -0.3px;
  transition: color 0.3s ease;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .chat-header h3 {
  color: #f9fafb;
}

.strategy-turn-counter {
  flex: 0 0 auto;
  margin-left: auto;
  padding: 0.28rem 0.58rem;
  border: 1px solid rgba(100, 116, 139, 0.35);
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.12);
  color: #475569;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.dark .strategy-turn-counter {
  border-color: rgba(148, 163, 184, 0.3);
  background: rgba(15, 23, 42, 0.3);
  color: #cbd5e1;
}

.strategy-turn-counter--warning,
.dark .strategy-turn-counter--warning {
  border-color: rgba(239, 68, 68, 0.62);
  background: rgba(239, 68, 68, 0.14);
  color: #ef4444;
}

.dark .strategy-turn-counter--warning {
  color: #fca5a5;
}

.App.App--single-column .chat-header {
  min-height: 4.35rem;
}

.compact-counsellor-selector {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.compact-counsellor-selector__trigger {
  height: 2.18rem;
  display: inline-flex;
  align-items: center;
  gap: 0.42rem;
  padding: 0 0.58rem;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  background: var(--surface-color);
  color: #374151;
  font-size: 0.74rem;
  font-weight: 650;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
}

.compact-counsellor-selector__trigger:hover,
.compact-counsellor-selector__trigger.open {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.compact-counsellor-selector__trigger:disabled {
  cursor: not-allowed;
  opacity: 0.62;
  background: #f3f4f6;
  border-color: #d1d5db;
  color: #6b7280;
}

.dark .compact-counsellor-selector__trigger {
  background: #374151;
  color: #f9fafb;
  border-color: #4b5563;
}

.dark .compact-counsellor-selector__trigger:hover,
.dark .compact-counsellor-selector__trigger.open {
  background: #4b5563;
  border-color: #6b7280;
}

.dark .compact-counsellor-selector__trigger:disabled {
  background: #1f2937;
  border-color: #374151;
  color: #9ca3af;
}

.compact-counsellor-selector__label {
  color: #6b7280;
  font-weight: 600;
}

.dark .compact-counsellor-selector__label {
  color: #d1d5db;
}

.compact-counsellor-selector__code {
  color: #111827;
  font-weight: 800;
}

.dark .compact-counsellor-selector__code {
  color: #f9fafb;
}

.compact-counsellor-selector__arrow {
  color: #6b7280;
  font-size: 0.72rem;
  transform: translateY(-0.02rem);
}

.dark .compact-counsellor-selector__arrow {
  color: #d1d5db;
}

.compact-counsellor-dropdown {
  min-width: 178px;
}

.chat-compact-mode-selector-shell {
  position: absolute;
  top: 0.9rem;
  left: 1rem;
  z-index: 35;
  pointer-events: none;
}

.chat-compact-mode-selector-shell--below-header {
  top: calc(5.5rem + 0.7rem);
}

.chat-mode-selector-shell {
  pointer-events: auto;
}

.chat-empty-mode-selector-shell {
  position: absolute;
  left: 50%;
  bottom: 6.25rem;
  z-index: 2;
  width: min(40rem, calc(100% - 3rem));
  display: flex;
  align-items: flex-start;
  justify-content: center;
  pointer-events: auto;
  transform: translateX(-50%);
}

.oars-exercise-counter {
  font-size: 0.84rem;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}

.dark .oars-exercise-counter {
  color: #9ca3af;
}

.oars-header-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
  flex-shrink: 0;
}

.oars-header-meta .oars-change-goal-pill {
  width: auto;
  max-width: none;
}

.oars-selected-bar {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem var(--app-chat-header-padding-inline, 2rem);
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.dark .oars-selected-bar {
  border-bottom-color: #374151;
}

.oars-selected-label {
  font-size: 0.79rem;
  color: #6b7280;
  font-weight: 500;
}

.dark .oars-selected-label {
  color: #9ca3af;
}

.oars-selected-chip {
  padding: 0.2rem 0.7rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.78rem;
  font-weight: 500;
}

.oars-filter-btn {
  padding: 0.3rem 0.85rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.79rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  background: transparent;
  color: #6b7280;
  border-color: #d1d5db;
}

.dark .oars-filter-btn {
  color: #9ca3af;
  border-color: #374151;
}

.oars-filter-btn:hover:not(.active) {
  background: rgba(0, 0, 0, 0.05);
}

.dark .oars-filter-btn:hover:not(.active) {
  background: rgba(255, 255, 255, 0.05);
}

.oars-filter-btn--all.active {
  background: rgba(107, 114, 128, 0.15);
  border-color: rgba(107, 114, 128, 0.4);
  color: #374151;
}

.dark .oars-filter-btn--all.active {
  background: rgba(156, 163, 175, 0.15);
  border-color: rgba(156, 163, 175, 0.4);
  color: #e5e7eb;
}

.oars-filter-btn--o.active {
  background: rgba(74, 158, 255, 0.12);
  border-color: rgba(74, 158, 255, 0.5);
  color: #4a9eff;
}

.oars-filter-btn--a.active {
  background: rgba(76, 175, 136, 0.12);
  border-color: rgba(76, 175, 136, 0.5);
  color: #4caf88;
}

.oars-filter-btn--r.active {
  background: rgba(201, 126, 240, 0.12);
  border-color: rgba(201, 126, 240, 0.5);
  color: #c97ef0;
}

.oars-filter-btn--s.active {
  background: rgba(240, 168, 78, 0.12);
  border-color: rgba(240, 168, 78, 0.5);
  color: #f0a84e;
}

.oars-change-goal-pill {
  display: inline-grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  column-gap: 0.35rem;
  row-gap: 0;
  padding: 0.42rem 0.8rem;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f3f4f6;
  color: #374151;
  font-size: 0.79rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  width: min(21rem, 100%);
  max-width: 100%;
  min-width: 0;
}

.oars-change-goal-pill__label {
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}

.oars-change-goal-pill__value {
  color: #374151;
  min-width: 0;
  white-space: nowrap;
}

.dark .oars-change-goal-pill {
  border-color: #4b5563;
  background: #374151;
  color: #e5e7eb;
}

.dark .oars-change-goal-pill__label,
.dark .oars-change-goal-pill__value {
  color: #d1d5db;
}

.counsellor-btn-group {
  position: relative;
  display: flex;
  align-items: stretch;
}

.llm-mode-btn {
  padding: 0.5rem 1rem;
  background: var(--surface-color);
  color: #374151;
  border: 1px solid #d1d5db;
  border-right: none;
  border-radius: 6px 0 0 6px;
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.dark .llm-mode-btn {
  background: #374151;
  color: #f9fafb;
  border-color: #4b5563;
}

.llm-mode-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.dark .llm-mode-btn:hover {
  background: #4b5563;
  border-color: #6b7280;
}

.llm-mode-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.llm-mode-btn:disabled:hover {
  background: var(--surface-color);
  border-color: #d1d5db;
  transform: none;
}

.dark .llm-mode-btn:disabled:hover {
  background: #374151;
  border-color: #4b5563;
}

.llm-mode-dropdown-btn {
  padding: 0.5rem 0.55rem;
  background: var(--surface-color);
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0 6px 6px 0;
  font-size: 0.79rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  line-height: 1;
}

.dark .llm-mode-dropdown-btn {
  background: #374151;
  color: #f9fafb;
  border-color: #4b5563;
}

.llm-mode-dropdown-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.dark .llm-mode-dropdown-btn:hover {
  background: #4b5563;
  border-color: #6b7280;
}

.llm-mode-dropdown-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.counsellor-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: var(--surface-color);
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 200;
  min-width: 160px;
  overflow: hidden;
}

.dark .counsellor-dropdown {
  background: #1f2937;
  border-color: #4b5563;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.counsellor-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  padding: 0.5rem 1rem;
  text-align: left;
  background: none;
  border: none;
  font-size: 0.86rem;
  color: #374151;
  cursor: pointer;
  transition: background 0.15s ease;
}

.counsellor-dropdown-item-code {
  width: 2.15rem;
  flex-shrink: 0;
  font-weight: 700;
  color: #9ca3af;
}

.counsellor-dropdown-item-label {
  min-width: 0;
}

.dark .counsellor-dropdown-item {
  color: #f9fafb;
}

.dark .counsellor-dropdown-item-code {
  color: #9ca3af;
}

.counsellor-dropdown-item:hover {
  background: #f3f4f6;
}

.dark .counsellor-dropdown-item:hover {
  background: #374151;
}

.counsellor-dropdown-item.active {
  font-weight: 600;
  color: #2563eb;
}

.counsellor-dropdown-item.active .counsellor-dropdown-item-code {
  color: inherit;
}

.dark .counsellor-dropdown-item.active {
  color: #60a5fa;
}

.App.App--single-column .counsellor-btn-group {
  display: none;
}

.oars-cut-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;
  color: var(--text-muted, #888);
  font-size: 0.74rem;
  font-weight: 500;
  flex-shrink: 0;
}

.oars-cut-line {
  flex: 1 1;
  height: 1px;
  background: var(--border-color, rgba(255, 255, 255, 0.1));
}

.dark .oars-cut-indicator { color: #6b7280; }
.dark .oars-cut-line { background: #374151; }
.light .oars-cut-indicator { color: #9ca3af; }

.oars-skill-choice-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  margin: 0.35rem auto 0.8rem;
  width: min(100%, 32rem);
  padding: 0.62rem 0.8rem 0.72rem;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  background: #f8fafc;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

.dark .oars-skill-choice-panel {
  border-color: rgba(148, 163, 184, 0.18);
  background: #1c2630;
  box-shadow: 0 8px 20px rgba(2, 6, 23, 0.2);
}

.oars-skill-choice-panel--selection-cue {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.34),
    0 0 28px rgba(59, 130, 246, 0.46);
}

.dark .oars-skill-choice-panel--selection-cue {
  border-color: #60a5fa;
  background: #1e3a5f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.26),
    0 0 24px rgba(96, 165, 250, 0.34);
}

.oars-skill-choice-panel__header {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  align-items: center;
  text-align: center;
}

.oars-skill-choice-panel__label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(71, 85, 105, 0.82);
}

.dark .oars-skill-choice-panel__label {
  color: rgba(203, 213, 225, 0.72);
}

.oars-skill-choice-panel__actions {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  gap: 0.45rem;
  flex-shrink: 0;
  width: 100%;
  justify-content: center;
}

.oars-skill-choice-btn {
  border: 1px solid rgba(148, 163, 184, 0.38);
  background: #ffffff;
  color: #475569;
  border-radius: 8px;
  min-height: 32px;
  padding: 0.42rem 0.72rem;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.oars-skill-choice-btn:hover {
  border-color: rgba(148, 163, 184, 0.58);
  background: #eef2f7;
  color: #334155;
}

.oars-skill-choice-btn.selected {
  border-color: #2563eb;
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.2);
}

.dark .oars-skill-choice-btn {
  border-color: rgba(75, 85, 99, 0.5);
  background: #1f2937;
  color: #94a3b8;
}

.dark .oars-skill-choice-btn:hover {
  border-color: rgba(100, 116, 139, 0.6);
  background: #374151;
  color: #e2e8f0;
}

.dark .oars-skill-choice-btn.selected {
  border-color: #60a5fa;
  background: #2563eb;
  color: #f8fafc;
}

@media (max-width: 900px) {
  .oars-skill-choice-panel {
    width: min(100%, 21rem);
  }

  .oars-skill-choice-panel__actions {
    width: 100%;
  }

  .oars-skill-choice-btn {
    min-width: 0;
  }
}

.light .oars-cut-line { background: rgba(0, 0, 0, 0.1); }

.messages-container.oars-messages {
  padding: 0.5rem 1.5rem 12rem;
}

.App.App--single-column .messages-container.oars-messages {
  padding-top: 3.5rem;
}

.oars-messages .message {
  align-items: flex-start;
  gap: 0.55rem;
}

.oars-messages .message-bubble-shell {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  width: auto;
  max-width: 70%;
}

.oars-messages .message-bubble-shell > .message-text,
.oars-messages .message-bubble-shell > .message-text--markdown {
  max-width: none;
}

.oars-messages .message-bubble-shell > .message-text-plain {
  width: auto;
}

.oars-session-position-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  margin: 0 0 0.9rem 0;
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: center;
}

.light .oars-session-position-indicator { color: #64748b; }
.dark .oars-session-position-indicator { color: #cbd5e1; }

.oars-session-position-dots {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.oars-session-position-dots span {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.9;
}

.oars-session-position-text {
  line-height: 1.2;
}

.oars-info-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.15s;
  flex-shrink: 0;
}

.oars-info-btn:hover {
  color: #6b7280;
}

.dark .oars-info-btn {
  color: #6b7280;
}

.dark .oars-info-btn:hover {
  color: #9ca3af;
}

.oars-info-btn svg {
  width: 1.1rem;
  height: 1.1rem;
}

.oars-info-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.oars-info-modal {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 660px;
  height: min(660px, calc(100vh - 2rem));
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.dark .oars-info-modal {
  background: #1f2937;
}

.App.App--single-column .oars-info-overlay {
  padding: 0.75rem;
}

.App.App--single-column .oars-info-modal {
  height: min(520px, 76dvh);
}

.oars-info-modal__close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 1.75rem;
  height: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.15s;
  z-index: 1;
}

.oars-info-modal__close:hover { color: #374151; }
.dark .oars-info-modal__close { color: #6b7280; }
.dark .oars-info-modal__close:hover { color: #e5e7eb; }
.oars-info-modal__close svg { width: 1.1rem; height: 1.1rem; }

.oars-info-modal__tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0.75rem 1rem 0;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.dark .oars-info-modal__tabs {
  border-bottom-color: #374151;
}

.oars-info-tab {
  padding: 0.4rem 0.85rem;
  border-radius: 6px 6px 0 0;
  border: 1px solid transparent;
  border-bottom: none;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  background: transparent;
  color: #6b7280;
  transition: background 0.15s, color 0.15s;
  margin-bottom: -1px;
}

.dark .oars-info-tab { color: #9ca3af; }
.oars-info-tab:hover:not(.active) { background: rgba(0,0,0,0.05); }
.dark .oars-info-tab:hover:not(.active) { background: rgba(255,255,255,0.05); }

.oars-info-tab.active {
  background: #ffffff;
  border-color: #e5e7eb;
  border-bottom-color: #ffffff;
  color: #111827;
}

.dark .oars-info-tab.active {
  background: #1f2937;
  border-color: #374151;
  border-bottom-color: #1f2937;
  color: #f9fafb;
}

.oars-info-tab--o.active { color: #4a9eff; }
.oars-info-tab--a.active { color: #4caf88; }
.oars-info-tab--r.active { color: #c97ef0; }
.oars-info-tab--s.active { color: #f0a84e; }
.oars-info-tab--sq.active { color: #38bfa7; }

.oars-info-modal__body {
  padding: 1.25rem 1.5rem 1.5rem;
  overflow-y: auto;
  flex: 1 1;
  color: #374151;
  font-size: 0.9rem;
  line-height: 1.65;
}

.dark .oars-info-modal__body { color: #d1d5db; }

.oars-info-modal__body h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dark .oars-info-modal__body h3 { color: #f9fafb; }

.oars-info-manual-link {
  margin-left: auto;
  flex-shrink: 0;
}

.oars-info-modal__body p {
  margin: 0 0 0.75rem;
}

.oars-info-modal__body p:last-child { margin-bottom: 0; }

.oars-info-citation {
  margin-top: 1rem !important;
  padding-top: 0.75rem;
  border-top: 1px solid #e5e7eb;
  font-size: 0.78rem !important;
  color: #9ca3af !important;
  font-style: italic;
}

.dark .oars-info-citation {
  border-top-color: #374151;
  color: #6b7280 !important;
}

.oars-info-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  flex-shrink: 0;
}

.oars-info-chip--o { background: rgba(74,158,255,0.15); color: #4a9eff; }
.oars-info-chip--a { background: rgba(76,175,136,0.15); color: #4caf88; }
.oars-info-chip--r { background: rgba(201,126,240,0.15); color: #c97ef0; }
.oars-info-chip--s { background: rgba(240,168,78,0.15); color: #f0a84e; }
.oars-info-chip--sq { background: rgba(56,191,167,0.15); color: #239b86; }
.dark .oars-info-chip--sq { color: #5ed8c2; }

.oars-skill-modal__footer {
  padding: 0.75rem 1.5rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.oars-dismiss-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1 auto;
  justify-content: flex-start;
  min-width: 0;
  font-size: 0.82rem;
  color: #6b7280;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-align: left;
}

.dark .oars-dismiss-label {
  color: #9ca3af;
}

.oars-dismiss-label input[type="checkbox"] {
  flex-shrink: 0;
  cursor: pointer;
  width: 0.9rem;
  height: 0.9rem;
  accent-color: #6b7280;
}

.oars-modal-begin-btn {
  padding: 0.45rem 1.2rem;
  border-radius: 8px;
  border: none;
  background: #2563eb;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s ease;
}

.oars-modal-begin-btn:hover {
  background: #1d4ed8;
}

.dark .oars-modal-begin-btn {
  background: #3b82f6;
}

.dark .oars-modal-begin-btn:hover {
  background: #2563eb;
}

@media (max-width: 768px) {
  .App:not(.App--single-column) .chat-interface {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    min-height: 50vh;
    display: flex;
    flex-direction: column;
  }

  .App:not(.App--single-column).dark .chat-interface {
    background: rgba(31, 41, 55, 0.5);
  }

  .App:not(.App--single-column) .chat-header {
    padding: 0.75rem 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }

  .App:not(.App--single-column) .chat-header h3 {
    font-size: 0.9rem;
  }

  .App:not(.App--single-column) .chat-header-title-row {
    width: 100%;
    gap: 0.45rem;
    flex-wrap: wrap;
  }

  .App:not(.App--single-column) .oars-change-goal-pill {
    width: 100%;
  }

  .App:not(.App--single-column) .llm-mode-btn {
    font-size: 0.75rem;
    padding: 0.35rem 0.6rem;
  }

  .App:not(.App--single-column) .llm-mode-dropdown-btn {
    font-size: 0.75rem;
    padding: 0.35rem 0.45rem;
  }

  .App:not(.App--single-column) .chat-empty-state {
    padding: 1.5rem 1rem;
  }

  .App:not(.App--single-column) .chat-empty-state h2 {
    font-size: 1.25rem;
  }

  .App:not(.App--single-column) .chat-empty-state p {
    font-size: 0.85rem;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatInterface.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,sFAAsF;EACtF,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iGAAiG;EACjG,mBAAmB;EACnB,gCAAgC;EAChC,kCAAkC;EAClC,cAAc;EACd,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2DAA2D;EAC3D,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yDAAyD;AAC3D;;AAEA,4BAA4B,cAAc,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,6BAA6B,cAAc,EAAE;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oHAAoH;AACtH;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,wBAAwB,8BAA8B,EAAE;;AAExD;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,0CAA0C,cAAc,EAAE;AAC1D,yCAAyC,cAAc,EAAE;;AAEzD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;;AAEA,gCAAgC,cAAc,EAAE;AAChD,gCAAgC,cAAc,EAAE;AAChD,sCAAsC,cAAc,EAAE;AACtD,8BAA8B,aAAa,EAAE,cAAc,EAAE;;AAE7D;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,uBAAuB,cAAc,EAAE;AACvC,oCAAoC,4BAA4B,EAAE;AAClE,0CAA0C,kCAAkC,EAAE;;AAE9E;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,4BAA4B,cAAc,EAAE;;AAE5C;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,SAAO;EACP,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,+BAA+B,cAAc,EAAE;;AAE/C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,kCAAkC,cAAc,EAAE;;AAElD;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC,gBAAgB,EAAE;;AAExD;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB,iCAAiC,EAAE,cAAc,EAAE;AACxE,qBAAqB,iCAAiC,EAAE,cAAc,EAAE;AACxE,qBAAqB,kCAAkC,EAAE,cAAc,EAAE;AACzE,qBAAqB,iCAAiC,EAAE,cAAc,EAAE;AACxE,sBAAsB,iCAAiC,EAAE,cAAc,EAAE;AACzE,4BAA4B,cAAc,EAAE;;AAE5C;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oCAAoC;IACpC,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;AAEF","sourcesContent":[".chat-interface {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: var(--surface-color);\n  transition: background-color 0.3s ease;\n  position: relative;\n}\n\n.dark .chat-interface {\n  background: #1f2937;\n}\n\n.chat-empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 3rem 2rem 2rem;\n  text-align: center;\n  color: #6e6e80;\n  transition: color 0.3s ease;\n}\n\n.chat-empty-state.embedded {\n  padding-top: 2.6rem;\n}\n\n.chat-empty-state.entrance {\n  padding-top: 4.25rem;\n}\n\n.dark .chat-empty-state {\n  color: #9ca3af;\n}\n\n.chat-empty-state h2 {\n  color: #2c3e50;\n  margin-bottom: 0.5rem;\n  transition: color 0.3s ease;\n}\n\n.dark .chat-empty-state h2 {\n  color: #f9fafb;\n}\n\n.chat-empty-state p {\n  max-width: 35rem;\n}\n\n.chat-empty-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 6rem;\n  overflow: visible;\n}\n\n.chat-empty-copy h2 {\n  margin-top: 0;\n}\n\n.chat-empty-copy p {\n  margin: 0;\n}\n\n.chat-empty-single-column-prompt {\n  color: #4b5563;\n  font-size: 0.98rem;\n  font-weight: 600;\n  line-height: 1.35;\n  margin-top: 2.4rem !important;\n}\n\n.dark .chat-empty-single-column-prompt {\n  color: #d1d5db;\n}\n\n.oars-messages--loading {\n  padding-top: 1.5rem;\n}\n\n.oars-session-position-indicator--loading {\n  margin-bottom: 1rem;\n}\n\n.oars-loading-message {\n  opacity: 1;\n}\n\n.oars-loading-bubble {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 0.62rem;\n  min-width: min(33rem, 78%);\n  padding: 1rem 1.05rem;\n  border-radius: 18px;\n  background: #eef2f7;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n}\n\n.oars-loading-bubble::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.7), transparent);\n  animation: oarsLoadingSweep 1.8s infinite ease-in-out;\n}\n\n.dark .oars-loading-bubble {\n  background: #2a3445;\n  border-color: rgba(148, 163, 184, 0.18);\n}\n\n.dark .oars-loading-bubble::after {\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\n}\n\n.oars-loading-bubble--wide {\n  min-width: min(34rem, 80%);\n}\n\n.oars-loading-bubble--client {\n  min-width: min(24rem, 66%);\n  margin-right: auto;\n  background: #f5efe6;\n}\n\n.dark .oars-loading-bubble--client {\n  background: #3a3027;\n}\n\n.oars-loading-line {\n  display: block;\n  height: 0.78rem;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.42);\n}\n\n.dark .oars-loading-line {\n  background: rgba(203, 213, 225, 0.18);\n}\n\n.oars-loading-line--long {\n  width: 88%;\n}\n\n.oars-loading-line--mid {\n  width: 64%;\n}\n\n.oars-loading-line--short {\n  width: 42%;\n}\n\n.oars-cut-indicator--loading {\n  margin-top: 1rem;\n}\n\n@keyframes oarsLoadingSweep {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--app-chat-header-padding-block, 1.5rem) var(--app-chat-header-padding-inline, 2rem);\n  min-height: 4.68rem;\n  border-bottom: 1px solid #e5e7eb;\n  transition: border-color 0.3s ease;\n  flex-shrink: 0;\n  gap: 1rem;\n}\n\n.dark .chat-header {\n  border-bottom-color: #374151;\n}\n\n.chat-header-title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  min-width: 0;\n  flex: 1;\n  flex-wrap: nowrap;\n}\n\n.chat-header h3 {\n  margin: 0;\n  font-size: 0.98rem;\n  font-weight: 600;\n  color: #111827;\n  letter-spacing: -0.3px;\n  transition: color 0.3s ease;\n  flex: 1 1 auto;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark .chat-header h3 {\n  color: #f9fafb;\n}\n\n.strategy-turn-counter {\n  flex: 0 0 auto;\n  margin-left: auto;\n  padding: 0.28rem 0.58rem;\n  border: 1px solid rgba(100, 116, 139, 0.35);\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.12);\n  color: #475569;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.dark .strategy-turn-counter {\n  border-color: rgba(148, 163, 184, 0.3);\n  background: rgba(15, 23, 42, 0.3);\n  color: #cbd5e1;\n}\n\n.strategy-turn-counter--warning,\n.dark .strategy-turn-counter--warning {\n  border-color: rgba(239, 68, 68, 0.62);\n  background: rgba(239, 68, 68, 0.14);\n  color: #ef4444;\n}\n\n.dark .strategy-turn-counter--warning {\n  color: #fca5a5;\n}\n\n.App.App--single-column .chat-header {\n  min-height: 4.35rem;\n}\n\n.compact-counsellor-selector {\n  position: relative;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n}\n\n.compact-counsellor-selector__trigger {\n  height: 2.18rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.42rem;\n  padding: 0 0.58rem;\n  border: 1px solid #d1d5db;\n  border-radius: 7px;\n  background: var(--surface-color);\n  color: #374151;\n  font-size: 0.74rem;\n  font-weight: 650;\n  line-height: 1;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.compact-counsellor-selector__trigger:hover,\n.compact-counsellor-selector__trigger.open {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.compact-counsellor-selector__trigger:disabled {\n  cursor: not-allowed;\n  opacity: 0.62;\n  background: #f3f4f6;\n  border-color: #d1d5db;\n  color: #6b7280;\n}\n\n.dark .compact-counsellor-selector__trigger {\n  background: #374151;\n  color: #f9fafb;\n  border-color: #4b5563;\n}\n\n.dark .compact-counsellor-selector__trigger:hover,\n.dark .compact-counsellor-selector__trigger.open {\n  background: #4b5563;\n  border-color: #6b7280;\n}\n\n.dark .compact-counsellor-selector__trigger:disabled {\n  background: #1f2937;\n  border-color: #374151;\n  color: #9ca3af;\n}\n\n.compact-counsellor-selector__label {\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.dark .compact-counsellor-selector__label {\n  color: #d1d5db;\n}\n\n.compact-counsellor-selector__code {\n  color: #111827;\n  font-weight: 800;\n}\n\n.dark .compact-counsellor-selector__code {\n  color: #f9fafb;\n}\n\n.compact-counsellor-selector__arrow {\n  color: #6b7280;\n  font-size: 0.72rem;\n  transform: translateY(-0.02rem);\n}\n\n.dark .compact-counsellor-selector__arrow {\n  color: #d1d5db;\n}\n\n.compact-counsellor-dropdown {\n  min-width: 178px;\n}\n\n.chat-compact-mode-selector-shell {\n  position: absolute;\n  top: 0.9rem;\n  left: 1rem;\n  z-index: 35;\n  pointer-events: none;\n}\n\n.chat-compact-mode-selector-shell--below-header {\n  top: calc(5.5rem + 0.7rem);\n}\n\n.chat-mode-selector-shell {\n  pointer-events: auto;\n}\n\n.chat-empty-mode-selector-shell {\n  position: absolute;\n  left: 50%;\n  bottom: 6.25rem;\n  z-index: 2;\n  width: min(40rem, calc(100% - 3rem));\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  pointer-events: auto;\n  transform: translateX(-50%);\n}\n\n.oars-exercise-counter {\n  font-size: 0.84rem;\n  font-weight: 500;\n  color: #6b7280;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.dark .oars-exercise-counter {\n  color: #9ca3af;\n}\n\n.oars-header-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.oars-header-meta .oars-change-goal-pill {\n  width: auto;\n  max-width: none;\n}\n\n.oars-selected-bar {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.5rem var(--app-chat-header-padding-inline, 2rem);\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.dark .oars-selected-bar {\n  border-bottom-color: #374151;\n}\n\n.oars-selected-label {\n  font-size: 0.79rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.dark .oars-selected-label {\n  color: #9ca3af;\n}\n\n.oars-selected-chip {\n  padding: 0.2rem 0.7rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n\n.oars-filter-btn {\n  padding: 0.3rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 0.79rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  background: transparent;\n  color: #6b7280;\n  border-color: #d1d5db;\n}\n\n.dark .oars-filter-btn {\n  color: #9ca3af;\n  border-color: #374151;\n}\n\n.oars-filter-btn:hover:not(.active) {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.dark .oars-filter-btn:hover:not(.active) {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.oars-filter-btn--all.active {\n  background: rgba(107, 114, 128, 0.15);\n  border-color: rgba(107, 114, 128, 0.4);\n  color: #374151;\n}\n\n.dark .oars-filter-btn--all.active {\n  background: rgba(156, 163, 175, 0.15);\n  border-color: rgba(156, 163, 175, 0.4);\n  color: #e5e7eb;\n}\n\n.oars-filter-btn--o.active {\n  background: rgba(74, 158, 255, 0.12);\n  border-color: rgba(74, 158, 255, 0.5);\n  color: #4a9eff;\n}\n\n.oars-filter-btn--a.active {\n  background: rgba(76, 175, 136, 0.12);\n  border-color: rgba(76, 175, 136, 0.5);\n  color: #4caf88;\n}\n\n.oars-filter-btn--r.active {\n  background: rgba(201, 126, 240, 0.12);\n  border-color: rgba(201, 126, 240, 0.5);\n  color: #c97ef0;\n}\n\n.oars-filter-btn--s.active {\n  background: rgba(240, 168, 78, 0.12);\n  border-color: rgba(240, 168, 78, 0.5);\n  color: #f0a84e;\n}\n\n.oars-change-goal-pill {\n  display: inline-grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  column-gap: 0.35rem;\n  row-gap: 0;\n  padding: 0.42rem 0.8rem;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  background: #f3f4f6;\n  color: #374151;\n  font-size: 0.79rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  width: min(21rem, 100%);\n  max-width: 100%;\n  min-width: 0;\n}\n\n.oars-change-goal-pill__label {\n  color: #6b7280;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.oars-change-goal-pill__value {\n  color: #374151;\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.dark .oars-change-goal-pill {\n  border-color: #4b5563;\n  background: #374151;\n  color: #e5e7eb;\n}\n\n.dark .oars-change-goal-pill__label,\n.dark .oars-change-goal-pill__value {\n  color: #d1d5db;\n}\n\n.counsellor-btn-group {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n}\n\n.llm-mode-btn {\n  padding: 0.5rem 1rem;\n  background: var(--surface-color);\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-right: none;\n  border-radius: 6px 0 0 6px;\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.dark .llm-mode-btn {\n  background: #374151;\n  color: #f9fafb;\n  border-color: #4b5563;\n}\n\n.llm-mode-btn:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.dark .llm-mode-btn:hover {\n  background: #4b5563;\n  border-color: #6b7280;\n}\n\n.llm-mode-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.llm-mode-btn:disabled:hover {\n  background: var(--surface-color);\n  border-color: #d1d5db;\n  transform: none;\n}\n\n.dark .llm-mode-btn:disabled:hover {\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.llm-mode-dropdown-btn {\n  padding: 0.5rem 0.55rem;\n  background: var(--surface-color);\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0 6px 6px 0;\n  font-size: 0.79rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n}\n\n.dark .llm-mode-dropdown-btn {\n  background: #374151;\n  color: #f9fafb;\n  border-color: #4b5563;\n}\n\n.llm-mode-dropdown-btn:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.dark .llm-mode-dropdown-btn:hover {\n  background: #4b5563;\n  border-color: #6b7280;\n}\n\n.llm-mode-dropdown-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.counsellor-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: var(--surface-color);\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  z-index: 200;\n  min-width: 160px;\n  overflow: hidden;\n}\n\n.dark .counsellor-dropdown {\n  background: #1f2937;\n  border-color: #4b5563;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.counsellor-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  width: 100%;\n  padding: 0.5rem 1rem;\n  text-align: left;\n  background: none;\n  border: none;\n  font-size: 0.86rem;\n  color: #374151;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.counsellor-dropdown-item-code {\n  width: 2.15rem;\n  flex-shrink: 0;\n  font-weight: 700;\n  color: #9ca3af;\n}\n\n.counsellor-dropdown-item-label {\n  min-width: 0;\n}\n\n.dark .counsellor-dropdown-item {\n  color: #f9fafb;\n}\n\n.dark .counsellor-dropdown-item-code {\n  color: #9ca3af;\n}\n\n.counsellor-dropdown-item:hover {\n  background: #f3f4f6;\n}\n\n.dark .counsellor-dropdown-item:hover {\n  background: #374151;\n}\n\n.counsellor-dropdown-item.active {\n  font-weight: 600;\n  color: #2563eb;\n}\n\n.counsellor-dropdown-item.active .counsellor-dropdown-item-code {\n  color: inherit;\n}\n\n.dark .counsellor-dropdown-item.active {\n  color: #60a5fa;\n}\n\n.App.App--single-column .counsellor-btn-group {\n  display: none;\n}\n\n.oars-cut-indicator {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 8px 0;\n  color: var(--text-muted, #888);\n  font-size: 0.74rem;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.oars-cut-line {\n  flex: 1;\n  height: 1px;\n  background: var(--border-color, rgba(255, 255, 255, 0.1));\n}\n\n.dark .oars-cut-indicator { color: #6b7280; }\n.dark .oars-cut-line { background: #374151; }\n.light .oars-cut-indicator { color: #9ca3af; }\n\n.oars-skill-choice-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  margin: 0.35rem auto 0.8rem;\n  width: min(100%, 32rem);\n  padding: 0.62rem 0.8rem 0.72rem;\n  border-radius: 14px;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  background: #f8fafc;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);\n}\n\n.dark .oars-skill-choice-panel {\n  border-color: rgba(148, 163, 184, 0.18);\n  background: #1c2630;\n  box-shadow: 0 8px 20px rgba(2, 6, 23, 0.2);\n}\n\n.oars-skill-choice-panel--selection-cue {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.34),\n    0 0 28px rgba(59, 130, 246, 0.46);\n}\n\n.dark .oars-skill-choice-panel--selection-cue {\n  border-color: #60a5fa;\n  background: #1e3a5f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.26),\n    0 0 24px rgba(96, 165, 250, 0.34);\n}\n\n.oars-skill-choice-panel__header {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n  align-items: center;\n  text-align: center;\n}\n\n.oars-skill-choice-panel__label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(71, 85, 105, 0.82);\n}\n\n.dark .oars-skill-choice-panel__label {\n  color: rgba(203, 213, 225, 0.72);\n}\n\n.oars-skill-choice-panel__actions {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  align-items: center;\n  gap: 0.45rem;\n  flex-shrink: 0;\n  width: 100%;\n  justify-content: center;\n}\n\n.oars-skill-choice-btn {\n  border: 1px solid rgba(148, 163, 184, 0.38);\n  background: #ffffff;\n  color: #475569;\n  border-radius: 8px;\n  min-height: 32px;\n  padding: 0.42rem 0.72rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.oars-skill-choice-btn:hover {\n  border-color: rgba(148, 163, 184, 0.58);\n  background: #eef2f7;\n  color: #334155;\n}\n\n.oars-skill-choice-btn.selected {\n  border-color: #2563eb;\n  background: #2563eb;\n  color: #ffffff;\n  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.2);\n}\n\n.dark .oars-skill-choice-btn {\n  border-color: rgba(75, 85, 99, 0.5);\n  background: #1f2937;\n  color: #94a3b8;\n}\n\n.dark .oars-skill-choice-btn:hover {\n  border-color: rgba(100, 116, 139, 0.6);\n  background: #374151;\n  color: #e2e8f0;\n}\n\n.dark .oars-skill-choice-btn.selected {\n  border-color: #60a5fa;\n  background: #2563eb;\n  color: #f8fafc;\n}\n\n@media (max-width: 900px) {\n  .oars-skill-choice-panel {\n    width: min(100%, 21rem);\n  }\n\n  .oars-skill-choice-panel__actions {\n    width: 100%;\n  }\n\n  .oars-skill-choice-btn {\n    min-width: 0;\n  }\n}\n\n.light .oars-cut-line { background: rgba(0, 0, 0, 0.1); }\n\n.messages-container.oars-messages {\n  padding: 0.5rem 1.5rem 12rem;\n}\n\n.App.App--single-column .messages-container.oars-messages {\n  padding-top: 3.5rem;\n}\n\n.oars-messages .message {\n  align-items: flex-start;\n  gap: 0.55rem;\n}\n\n.oars-messages .message-bubble-shell {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  width: auto;\n  max-width: 70%;\n}\n\n.oars-messages .message-bubble-shell > .message-text,\n.oars-messages .message-bubble-shell > .message-text--markdown {\n  max-width: none;\n}\n\n.oars-messages .message-bubble-shell > .message-text-plain {\n  width: auto;\n}\n\n.oars-session-position-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  width: 100%;\n  margin: 0 0 0.9rem 0;\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  text-align: center;\n}\n\n.light .oars-session-position-indicator { color: #64748b; }\n.dark .oars-session-position-indicator { color: #cbd5e1; }\n\n.oars-session-position-dots {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.oars-session-position-dots span {\n  width: 4px;\n  height: 4px;\n  border-radius: 999px;\n  background: currentColor;\n  opacity: 0.9;\n}\n\n.oars-session-position-text {\n  line-height: 1.2;\n}\n\n.oars-info-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #9ca3af;\n  transition: color 0.15s;\n  flex-shrink: 0;\n}\n\n.oars-info-btn:hover {\n  color: #6b7280;\n}\n\n.dark .oars-info-btn {\n  color: #6b7280;\n}\n\n.dark .oars-info-btn:hover {\n  color: #9ca3af;\n}\n\n.oars-info-btn svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.oars-info-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.oars-info-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 660px;\n  height: min(660px, calc(100vh - 2rem));\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.dark .oars-info-modal {\n  background: #1f2937;\n}\n\n.App.App--single-column .oars-info-overlay {\n  padding: 0.75rem;\n}\n\n.App.App--single-column .oars-info-modal {\n  height: min(520px, 76dvh);\n}\n\n.oars-info-modal__close {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  width: 1.75rem;\n  height: 1.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #9ca3af;\n  transition: color 0.15s;\n  z-index: 1;\n}\n\n.oars-info-modal__close:hover { color: #374151; }\n.dark .oars-info-modal__close { color: #6b7280; }\n.dark .oars-info-modal__close:hover { color: #e5e7eb; }\n.oars-info-modal__close svg { width: 1.1rem; height: 1.1rem; }\n\n.oars-info-modal__tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0.75rem 1rem 0;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.dark .oars-info-modal__tabs {\n  border-bottom-color: #374151;\n}\n\n.oars-info-tab {\n  padding: 0.4rem 0.85rem;\n  border-radius: 6px 6px 0 0;\n  border: 1px solid transparent;\n  border-bottom: none;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  background: transparent;\n  color: #6b7280;\n  transition: background 0.15s, color 0.15s;\n  margin-bottom: -1px;\n}\n\n.dark .oars-info-tab { color: #9ca3af; }\n.oars-info-tab:hover:not(.active) { background: rgba(0,0,0,0.05); }\n.dark .oars-info-tab:hover:not(.active) { background: rgba(255,255,255,0.05); }\n\n.oars-info-tab.active {\n  background: #ffffff;\n  border-color: #e5e7eb;\n  border-bottom-color: #ffffff;\n  color: #111827;\n}\n\n.dark .oars-info-tab.active {\n  background: #1f2937;\n  border-color: #374151;\n  border-bottom-color: #1f2937;\n  color: #f9fafb;\n}\n\n.oars-info-tab--o.active { color: #4a9eff; }\n.oars-info-tab--a.active { color: #4caf88; }\n.oars-info-tab--r.active { color: #c97ef0; }\n.oars-info-tab--s.active { color: #f0a84e; }\n.oars-info-tab--sq.active { color: #38bfa7; }\n\n.oars-info-modal__body {\n  padding: 1.25rem 1.5rem 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n  color: #374151;\n  font-size: 0.9rem;\n  line-height: 1.65;\n}\n\n.dark .oars-info-modal__body { color: #d1d5db; }\n\n.oars-info-modal__body h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 0.85rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dark .oars-info-modal__body h3 { color: #f9fafb; }\n\n.oars-info-manual-link {\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.oars-info-modal__body p {\n  margin: 0 0 0.75rem;\n}\n\n.oars-info-modal__body p:last-child { margin-bottom: 0; }\n\n.oars-info-citation {\n  margin-top: 1rem !important;\n  padding-top: 0.75rem;\n  border-top: 1px solid #e5e7eb;\n  font-size: 0.78rem !important;\n  color: #9ca3af !important;\n  font-style: italic;\n}\n\n.dark .oars-info-citation {\n  border-top-color: #374151;\n  color: #6b7280 !important;\n}\n\n.oars-info-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.oars-info-chip--o { background: rgba(74,158,255,0.15); color: #4a9eff; }\n.oars-info-chip--a { background: rgba(76,175,136,0.15); color: #4caf88; }\n.oars-info-chip--r { background: rgba(201,126,240,0.15); color: #c97ef0; }\n.oars-info-chip--s { background: rgba(240,168,78,0.15); color: #f0a84e; }\n.oars-info-chip--sq { background: rgba(56,191,167,0.15); color: #239b86; }\n.dark .oars-info-chip--sq { color: #5ed8c2; }\n\n.oars-skill-modal__footer {\n  padding: 0.75rem 1.5rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.oars-dismiss-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1 1 auto;\n  justify-content: flex-start;\n  min-width: 0;\n  font-size: 0.82rem;\n  color: #6b7280;\n  cursor: pointer;\n  user-select: none;\n  text-align: left;\n}\n\n.dark .oars-dismiss-label {\n  color: #9ca3af;\n}\n\n.oars-dismiss-label input[type=\"checkbox\"] {\n  flex-shrink: 0;\n  cursor: pointer;\n  width: 0.9rem;\n  height: 0.9rem;\n  accent-color: #6b7280;\n}\n\n.oars-modal-begin-btn {\n  padding: 0.45rem 1.2rem;\n  border-radius: 8px;\n  border: none;\n  background: #2563eb;\n  color: #ffffff;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.oars-modal-begin-btn:hover {\n  background: #1d4ed8;\n}\n\n.dark .oars-modal-begin-btn {\n  background: #3b82f6;\n}\n\n.dark .oars-modal-begin-btn:hover {\n  background: #2563eb;\n}\n\n@media (max-width: 768px) {\n  .App:not(.App--single-column) .chat-interface {\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    min-height: 50vh;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .App:not(.App--single-column).dark .chat-interface {\n    background: rgba(31, 41, 55, 0.5);\n  }\n\n  .App:not(.App--single-column) .chat-header {\n    padding: 0.75rem 1rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n  }\n\n  .App:not(.App--single-column) .chat-header h3 {\n    font-size: 0.9rem;\n  }\n\n  .App:not(.App--single-column) .chat-header-title-row {\n    width: 100%;\n    gap: 0.45rem;\n    flex-wrap: wrap;\n  }\n\n  .App:not(.App--single-column) .oars-change-goal-pill {\n    width: 100%;\n  }\n\n  .App:not(.App--single-column) .llm-mode-btn {\n    font-size: 0.75rem;\n    padding: 0.35rem 0.6rem;\n  }\n\n  .App:not(.App--single-column) .llm-mode-dropdown-btn {\n    font-size: 0.75rem;\n    padding: 0.35rem 0.45rem;\n  }\n\n  .App:not(.App--single-column) .chat-empty-state {\n    padding: 1.5rem 1rem;\n  }\n\n  .App:not(.App--single-column) .chat-empty-state h2 {\n    font-size: 1.25rem;\n  }\n\n  .App:not(.App--single-column) .chat-empty-state p {\n    font-size: 0.85rem;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
